import { OpenAPI as FeatureGatingApi } from 'services/featuregating/generated';
import { authStore } from 'stores/AuthStore';

const getString = (key: string, defaultValue: string = '') => `${(window as any)[key] || defaultValue}`;

const FEATUREGATING_API_URL = getString('FEATUREGATING_API_URL');
const OKTA_ISSUER = getString('OKTA_ISSUER');
const OKTA_CLIENT_ID = getString('OKTA_CLIENT_ID');

FeatureGatingApi.BASE = FEATUREGATING_API_URL;
FeatureGatingApi.TOKEN = () => Promise.resolve(`${authStore.accessToken}`);

interface Config
{
  docroot: string;
  okta:
  {
    authority: string;
    clientId: string;
  };
}

const config: Config =
{
  docroot: '/',
  okta:
  {
    authority: OKTA_ISSUER,
    clientId: OKTA_CLIENT_ID,
  },
};
export default config;
